module.exports = __webpack_public_path__ + "img/network-wired.02640abe.svg";